import * as React from "react";
import PolizaForm from "./form/PolizaForm";

var NewPoliza = function NewPoliza(props) {
  var _props$companies = props.companies,
      companies = _props$companies === void 0 ? [] : _props$companies,
      _props$regions = props.regions,
      regions = _props$regions === void 0 ? [] : _props$regions,
      _props$channels = props.channels,
      channels = _props$channels === void 0 ? [] : _props$channels,
      _props$cities = props.cities,
      cities = _props$cities === void 0 ? [] : _props$cities,
      _props$comunas = props.comunas,
      comunas = _props$comunas === void 0 ? [] : _props$comunas,
      _props$banks = props.banks,
      banks = _props$banks === void 0 ? [] : _props$banks,
      token = props.token,
      _props$insurance_brok = props.insurance_broker_agents,
      insurance_broker_agents = _props$insurance_brok === void 0 ? [] : _props$insurance_brok;
  var companiesOption = companies && companies.map(function (company) {
    return {
      label: company.name,
      value: company.id
    };
  });
  var banksOption = banks && banks.map(function (bank) {
    return {
      label: bank.name,
      value: bank.id
    };
  });
  return /*#__PURE__*/React.createElement(PolizaForm, {
    companiesOption: companiesOption,
    banksOption: banksOption,
    token: token,
    channels: channels,
    regions: regions || [],
    comunas: comunas || [],
    companies: companies,
    insuranceBrokerAgents: insurance_broker_agents
  });
};

export default NewPoliza;